// CSS Imports
import "./sass/site.scss";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.css";
import "../node_modules/font-awesome/css/font-awesome.css";

// Polyfills
import "core-js";
import "regenerator-runtime/runtime";

// Vendor Js Imports
import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "bootstrap";
import "bootstrap-datepicker";

// Client Js Imports
import "./js/forms";
import "./js/password-reveal";
import "./js/signout-redirect";
import "./js/register/register";
import "./js/time-remaining";
